
import { getTokenClientes } from "../../Store/storages/AuthenticationStorage";
import { apiClientes } from "../../config/api";
import { HistoricoItem } from "../../interfaces/entities/SaudeBemEstar/AutoAvaliacao/HistoricoItem";
import { PerguntaItem } from "../../interfaces/entities/SaudeBemEstar/AutoAvaliacao/PerguntaItem";
import { RespostaItem } from "../../interfaces/entities/SaudeBemEstar/AutoAvaliacao/RespostaItem";
import { Resultado } from "../../interfaces/entities/SaudeBemEstar/AutoAvaliacao/Resultado";
import { Prestador } from "../../interfaces/entities/SaudeBemEstar/Agendamento/Prestador";
import { Horario } from "../../interfaces/entities/SaudeBemEstar/Agendamento/Horario";
import { Agendamento } from "../../interfaces/entities/Agendamento";
import { TipoHistoricoEnum } from "../../interfaces/entities/SaudeBemEstar/AutoAvaliacao/TipoHistoricoEnum";
import { Response } from "../../interfaces/services/Response";
import { RetornaAceiteTermoResponse } from "../../interfaces/entities/RetornaAceiteTermoResponse";
import { AxiosError } from "axios";

export const getHistoricoDataAvaliacao = (): Promise<HistoricoItem[]> => {

	const getTipo = (icon: string) => {
		if (icon.includes('fa-thermometer-empty')) {
			return TipoHistoricoEnum.Baixo
		} else if (icon.includes('fa-thermometer-full')) {
			return TipoHistoricoEnum.Elevado
		} else {
			return TipoHistoricoEnum.Moderado
		}
	}

	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get("/SaudeEmocional/GetHistoricoDataAvaliacao", { headers });

			if (response.data) {
				resolve(response.data.map((item: any) => ({
					data: item.data,
					hora: item.hora,
					tipo: getTipo(item.iconface),
					idRespQuestBenef: item.id_resp_quest_benef
				})))
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
};

export const getHistoricoAvaliacao = async (idRespQuestBenef: number): Promise<Response | null> => {
	try {
		const response = await apiClientes.get(`/SaudeEmocional/GetHistoricoAvaliacao?idRespQuestBenef=${idRespQuestBenef}`, {
			headers: { Authorization: `Bearer ${await getTokenClientes()}` }
		});
		return response;
	} catch (error: any) {
		console.log({ error });
		return null;
	}
};


export const getEmQualNivelMeEncontro = (): Promise<{ texto: string[], images: string[] }> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get("/SaudeEmocional/GetEmQualNivelMeEncontro", { headers });

			if (response?.data?.lstTextos) {
				const lstTextos: { texto: string, imagem: string }[] = response.data.lstTextos
				const result = {
					texto: lstTextos.map(item => item.texto).filter(txt => txt.length > 0),
					images: lstTextos.map(item => item.imagem).filter(img => img.length > 0)
				}
				resolve(result)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getIniciarAvaliacao = (): Promise<string[]> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get("/SaudeEmocional/GetIniciarAvaliacao", { headers });

			console.log(response.data)
			if (response?.data?.lstTextos) {
				resolve(response.data.lstTextos.map((item: { texto: string; }) => item.texto))
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getInstrucoes = (): Promise<Response | null> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get("/SaudeEmocional/GetInstrucoes", { headers });

			if (response.data) {
				resolve(response.data)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getMostrarNovamenteBoasVindas = (): Promise<RetornaAceiteTermoResponse | null> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get("/SaudeEmocional/GetMostrarNovamenteBoasVindas", { headers });

			if (response.data) {
				resolve(response.data)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getRefazerAvaliacao = (): Promise<Response | null> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get("/SaudeEmocional/GetRefazerAvaliacaoSaudeEmocional", { headers });

			if (response.data) {
				resolve(response)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getRetornaAceiteSaudeEmocional = (): Promise<Response | null> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get("/SaudeEmocional/RetornaAceiteSaudeEmocional", { headers });

			if (response.data) {
				resolve(response.data)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const aceiteNaoMostrarNovamente = (idTermoResponsabilidade: number, idOperador: number): Promise<Response | null> => {
	return new Promise(async (resolve, reject) => {
		try {
			const payload = {
				idOperador,
				idTermoResponsabilidade,
				indAceite: 'S'
			}

			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.post("SaudeEmocional/AceiteNaoMostrarNovamente",
				payload,
				{ headers });

			if (response?.data) {
				resolve(response.data)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getQuestoesAvaliacao = (): Promise<PerguntaItem[]> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get("/SaudeEmocional/GetQuestoesAvaliacao", { headers });

			if (response.data) {
				resolve(response.data)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getResultado = (idResp: string): Promise<Resultado> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get(`/SaudeEmocional/GetResultado?idRespQuestBenef=${idResp}`, { headers });

			if (response.data) {
				resolve(response.data as Resultado)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getResultadoAvaliacao = (detalheAvaliacao: string): Promise<Resultado> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get(`/SaudeEmocional/GetResultadoAvaliacao?detalheAvaliacao=${detalheAvaliacao}`, { headers });

			if (response.data) {
				resolve(response.data as Resultado)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const postRepostaQuestionarioAvaliacao = (data: RespostaItem[]): Promise<Response | null> => {
	return new Promise(async (resolve, reject) => {
		try {
			const payload = data.map(item => ({
				codTipoQuestaoTeleOrient: "RADIO",
				idQuestaoTeleOrientAnterior: "",
				resposta: item.resposta,
				idRespQuestBenef: item.idRespQuestBenef,
				lstQuestoesTriagem: item.lstQuestoesTriagem
			}))

			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.post("/SaudeEmocional/SalvarRespQuestAvaliacao",
				payload,
				{ headers });

			if (response?.data) {
				resolve(response.data)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getAceiteSaudeEmocional = (): Promise<boolean> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get('/TermoResponsabilidade/RetornaAceiteSaudeEmocional', { headers });

			if (response?.data) {
				resolve(response.data.indAceite === 'S')
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getTermoSaudeEmocional = (): Promise<{ descricao: string, idTermoResponsabilidade: string }> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get('/TermoResponsabilidade/RetornaTermoResponsabilidadeSaudeEmocional', { headers });

			if (response.data) {
				resolve(response.data)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const postAceiteSaudeEmocional = (idTermo: number, aceite: boolean): Promise<Response | null> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get(`/TermoResponsabilidade/AceitaTermoResponsabilidade?idTermo=${idTermo}&indAceite=${aceite ? 'S' : 'N'}`, { headers });

			if (response.data) {
				resolve(response.data)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getHorariosDisponiveis = (idPrestador: number, idInstal: number, dtInicial: string, dtFinal: string): Promise<Response | null> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get(`/SaudeEmocional/GetHorariosDisponiveisPeriodo?idPrestador=${idPrestador}&idInstal=${idInstal}&dtInicial=${dtInicial}&dtFinal=${dtFinal}`, { headers });

			if (response.data) {
				resolve(response.data)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getPrestadores = (): Promise<Prestador[]> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get('/SaudeEmocional/GetPrestadores', { headers });

			if (response.data) {
				resolve(response.data.map((item: any) => ({
					especialidade: item.descrEspec,
					idInstal: item.idInstal,
					idPessoa: item.idPessoa,
					nome: item.nome,
					dtProvavelDisponibilidade: item.dtProvavelDisponibilidade
				})))
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getCVPrestador = (idPrestador: string): Promise<string> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get(`/SaudeEmocional/GetCVPrestador?idPrestador=${idPrestador}`, { headers });

			if (response?.data) {
				resolve(response.data.cv)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getHorariosDisponiveisPeriodo = (
	idPrestador: string,
	idInstal: string,
	dtInicial: string,
	dtFinal: string,
): Promise<Horario[]> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };

			const response = await apiClientes.get(
				`/SaudeEmocional/GetHorariosDisponiveisPeriodo?idPrestador=${idPrestador}&idInstal=${idInstal}&dtInicial=${dtInicial}&dtFinal=${dtFinal}&tipoAtend=T`,
				{ headers });

			if (response?.data) {
				resolve(response.data)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const postAgendar = (
	idInstal: string,
	idPrestador: string,
	espec: string,
	data: string,
	cel: string,
	tel: string,
	email: string
): Promise<Response | null> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };

			const payload = {
				idInstal, idPrestador, espec, data,
				cel, tel, email
			}

			const response = await apiClientes.post(
				'/SaudeEmocional/agendar',
				payload,
				{ headers });

			if (response?.data) {
				resolve(response.data)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getAgendamentosSaudeEmocional = (): Promise<Agendamento[]> => {
	return new Promise(async (resolve, reject) => {
		try {
			const response = await apiClientes.get('/SaudeEmocional/GetAgendamentosSaudeEmocionalFuturos', {
				headers: { Authorization: `Bearer ${await getTokenClientes()}` }
			});
			if (response?.data) {
				resolve(response.data);
			} else {
				reject(response);
			}

		} catch (error) {
			console.log({ error });
			reject(error)
		}
	})
};

export const getBoasVindasAgendamento = (): Promise<{ textos: string[], imagens: string[] }> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get("/SaudeEmocional/GetBoasVindasAgendamento", { headers });

			if (response.data) {
				resolve(response.data)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getPermissoesSaudeEmocional = async (): Promise<Response | null> => {
	try {
		const response = await apiClientes.get(`/SaudeEmocional/Getpermissaoagendamento`, {
			headers: { Authorization: `Bearer ${await getTokenClientes()}` }
		});
		return response;
	} catch (error) {
		throw (error as AxiosError)?.response?.data;
	}
};

export const getMostrarNovamenteNivel = (): Promise<RetornaAceiteTermoResponse | null> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get("/SaudeEmocional/getmostrarnovamentenivel", { headers });

			if (response.data) {
				resolve(response.data)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getMostrarNovamenteNivelIniciar = (): Promise<RetornaAceiteTermoResponse | null> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get("/SaudeEmocional/getmostrarnovamenteniveliniciar", { headers });

			if (response.data) {
				resolve(response.data)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}

export const getMostrarNovamenteInstrucoes = (): Promise<RetornaAceiteTermoResponse | null> => {
	return new Promise(async (resolve, reject) => {
		try {
			const Authorization = `Bearer ${await getTokenClientes()}`;
			const headers = { Authorization };
			const response = await apiClientes.get("/SaudeEmocional/getmostrarnovamenteinstrucoes", { headers });

			if (response.data) {
				resolve(response.data)
			} else {
				reject(response)
			}
		} catch (error) {
			reject(error)
		}
	})
}